import type { FC } from "react";
import { ColorModeProvider } from "../color-mode";
import { Toaster } from "../toast";
import { type AppShellProps, AppShellWrapper } from "./app-shell-wrapper";
import { useEffect } from "react";
import { useAppShellStore } from "./store";

const DEFAULT_ROOT_FONT_SIZE = 0.85;

export const AppShell: FC<AppShellProps> = ({ children, topbarNavigation, sidebarNavigation }) => {
	/** Store */
	const { fontScale } = useAppShellStore();

	/** Effects */
	useEffect(() => {
		document.documentElement.style.setProperty(
			"--root-font-size",
			`${DEFAULT_ROOT_FONT_SIZE * fontScale}rem`,
		);
		document.documentElement.style.setProperty("--font-scale", String(fontScale));
	}, [fontScale]);

	/** Render */
	return (
		<ColorModeProvider>
			<Toaster />
			<AppShellWrapper
				sidebarNavigation={sidebarNavigation}
				topbarNavigation={topbarNavigation}
			>
				{children}
			</AppShellWrapper>
		</ColorModeProvider>
	);
};
